import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import PrivateRoute from "./Utility/PrivateRoute"

import { Provider, useDispatch, useSelector } from "react-redux";
import { AuthProvider } from "./authContext"
import store from "./Redux/Store";
import "./App.css";
import Loading from "./LoadingAnimation/Loading";
import Homepage from "./Scenes/Homepage";
import Navbar from "./navbar/Navbar";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Dashboard from './ServiceDashboard/dashboardTable'
import Alltable from './ServiceDashboard/allTable'

import Signup from "./Registration/Signup";
import ScrollToTop from "./Utility/Scrolltotop";
import Informationpage from "./quickMenu/Informationpage";
const Footer = lazy(() => import("./Footer/Footer"));
const Requests = lazy(() => import("./Scenes/Requests"));
const Profile = lazy(() => import("./ProfessionalAccount/ProfessionalAccount"));
const ServiceCharge = lazy(() => import("./PriicingTable/Pricingtable"));
const RequestForm = lazy(() => import("./Registration/RequestForm"));
const Customer = lazy(() => import("./Registration/Customer"));
const AboutUs = lazy(() => import("./Scenes/AboutUs"));
const Stastics = lazy(() => import("./navbar/Navbar"));
const Signin = lazy(() => import("./Registration/Signin"));
const Account = lazy(() => import("./Account/Account"));
const Error = lazy(() => import("./Error/Error"));

const Routing = () => {
  const dispatch = useDispatch();
  var data = useSelector((state) => state.user.user);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    const jwt = JSON.parse(localStorage.getItem("token"));
    if (user) {
      dispatch({ type: "LOG_IN", payload: true });
      dispatch({ type: "JWT", payload: jwt });
      dispatch({ type: "USER", payload: user });
    }
  }, [dispatch]);
  console.log(data.role);
  return (
    <Switch>
      <Route exact path="/" component={Homepage} />
          <PrivateRoute path="/stastics" component={Stastics} />
        <PrivateRoute path="/aboutservice" component={Informationpage} />
      <Route path="/register" component={Signup}/>
      <Route path="/pricing">
        <ServiceCharge />
      </Route>

      <Route path="/aboutus">
        <AboutUs />
      </Route>
      <Route path="/login" component={Signin} />

      {data.professional && (
        <PrivateRoute path="/requests" component={Requests} />
      )}
      {data.professional && (
        <PrivateRoute path="/account" component={Profile} />
      )}
      {!data.professional && (
        <PrivateRoute path="/account" component={Account} />
      )}

      <Route path="/activate" component={Customer} />

      <PrivateRoute path="/requestservice" component={RequestForm} />
      <Route>
        <Error />
      </Route>
    </Switch>
  );
};

const theme = createMuiTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 450,
            md: 800,
            lg: 1000,
            xl: 1400
        }
    }
});

function App() {
  // store.subscribe(async () => await console.log(store.getState()));

  return (
    <Provider store={store}>
              <AuthProvider>

        <ThemeProvider theme={theme}>
        <div className="App">
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <Navbar />
            <ScrollToTop>
              <Routing />
            </ScrollToTop>
            <Footer />
          </Suspense>
        </BrowserRouter>
      </div>
        </ThemeProvider>
</AuthProvider>
    </Provider>
  );
}
export const domain = 'http://localhost:5000'

export default React.memo(App);
